module.exports = __webpack_public_path__ + "img/oaFlowData159@3x.bfdb413d.png";